import ENV from "../env";

const getInvoice = async (invoiceId) => {
  const response = await fetch(`${ENV.firebaseApiUrl}/invoice/${invoiceId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });

  const resData = await response.json();

  if (!response.ok) {
    throw new Error(resData.message || "Failed to fetch invoice");
  }

  return resData.invoice;
};

export default getInvoice;
